import globals from "@homer.core/globals";
import page from "@homer.core/page";

const url = URL.resolve(location.href);
const id = url.parameter?.email?.id;
const token = url.parameter?.email?.token;

if (id && token) {
    url.searchParams.delete("email[id]");
    url.searchParams.delete("email[token]");
    page.replace(url.href);

    void globals.demand.request("@apfelkiste/user").then(([user]) => {
        user.emailEditConfirm(id, token);
    });
}
